import { useEffect, useState } from "react";

/**
 * Thin yellow banner at the very top of the app when the browser thinks
 * it's offline. Uses `navigator.onLine` + window online/offline events.
 * Auto-hides when connectivity returns.
 */
export function OfflineBanner() {
  const [online, setOnline] = useState(
    typeof navigator !== "undefined" ? navigator.onLine : true,
  );

  useEffect(() => {
    function onOnline() {
      setOnline(true);
    }
    function onOffline() {
      setOnline(false);
    }
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    return () => {
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
    };
  }, []);

  if (online) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        background: "var(--neo-amber-bg)",
        color: "var(--neo-amber)",
        borderBottom: "1px solid var(--neo-amber)",
        padding: "6px 16px",
        fontSize: 12,
        fontWeight: 600,
        textAlign: "center",
        letterSpacing: 0.2,
      }}
    >
      Offline — edits are kept in the browser and will sync once you're back
      online.
    </div>
  );
}
